import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import {Box, IconButton, Link} from '@material-ui/core'
import Icon from '@mdi/react'

//icons
import {
  mdiFacebook as FacebookIcon,
  mdiTwitter as TwitterIcon,
  mdiGithub as GithubIcon,
} from '@mdi/js'

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard";
import Typography from "../../pages/typography";
import Notifications from "../../pages/notifications";
import Maps from "../../pages/maps";
import Icons from "../../pages/icons";
import Charts from "../../pages/charts";
import Manager from "../../pages/managers/Managers";
import AtmTransaction from "../../pages/Transactions/atmTransactions";
import BankTransaction from "../../pages/Transactions/bankTransactions";
import LoanTransaction from "../../pages/Transactions/loanTransactions";
import OnlineTransaction from "../../pages/Transactions/onlineTransactions";
import CreateTransaction from "../../pages/Transactions/createTransactions";
import CreateAtmTransaction from "../../pages/Transactions/createAtmTransactions";
import CreateBankTransaction from "../../pages/Transactions/createBankTransactions";
import InstallmentTransaction from "../../pages/Transactions/installmentTransactions";
import CreateOnlineLoanRequest from "../../pages/createOnlineLoanRequests";
import CreateManualLoanRequest from "../../pages/createManualLoanRequests";
import LoanRequests from "../../pages/loanRequests/LoanRequests";
import Accounts from "../../pages/accounts/Accounts";
import AllLoans from "../../pages/loans/allLoans";
import OnlineLoans from "../../pages/loans/online-loans";
import DirectLoans from "../../pages/loans/direct-loans";
import RejectedLoans from "../../pages/loans/rejectedLoans";
import Branches from "../../pages/branches/Branches";
import Clerks from "../../pages/clerks/Clerks";
// context
import { useLayoutState } from "../../context/LayoutContext";

function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <>
          <Header history={props.history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/typography" component={Typography} />
              <Route path="/app/manager" component={Manager} />
              
              <Route path="/app/loanRequest" component={LoanRequests} />
              <Route path="/app/account" component={Accounts} />
              <Route path="/app/branch" component={Branches} />
              <Route path="/app/clerk" component={Clerks} />
              <Route path="/app/notifications" component={Notifications} />
              
              <Route
                exact
                path="/app/transaction"
                render={() => <Redirect to="/app/transaction/bank" />}
              />
              <Route path="/app/transaction/atm" component={AtmTransaction} />
              <Route path="/app/transaction/bank" component={BankTransaction} />
              <Route path="/app/transaction/online" component={OnlineTransaction} />
              <Route path="/app/transaction/loan" component={LoanTransaction} />
              <Route path="/app/transaction/create-transaction" component={CreateTransaction} />
              <Route path="/app/transaction/create-atm-transaction" component={CreateAtmTransaction} />
              <Route path="/app/transaction/create-bank-transaction" component={CreateBankTransaction} />
              <Route path="/app/transaction/installment-transaction" component={InstallmentTransaction} />
              <Route
                exact
                path="/app/ui"
                render={() => <Redirect to="/app/ui/icons" />}
              />
              <Route path="/app/ui/maps" component={Maps} />
              <Route path="/app/ui/icons" component={Icons} />
              <Route path="/app/ui/charts" component={Charts} />
              <Route
                exact
                path="/app/loan"
                render={() => <Redirect to="/app/loan/all-loans" />}
              />
              <Route path="/app/loan/all-loans" component={AllLoans} />
              <Route path="/app/loan/online-loans" component={OnlineLoans} />
              <Route path="/app/loan/direct-loans" component={DirectLoans} />
              <Route path="/app/loan/rejected-loans" component={RejectedLoans} />
              <Route path="/app/loan/request-online-loans" component={CreateOnlineLoanRequest} />
              <Route path="/app/loan/request-manual-loans" component={CreateManualLoanRequest} />
              
            </Switch>
            <Box
              mt={5}
              width={"100%"}
              position= {"fixed"}
              display={"flex"}
              alignItems={"center"}
              justifyContent="space-between"
            >
              <div>
                <Link
                  color={'primary'}
                  href={'https://flatlogic.com/'}
                  target={'_blank'}
                  className={classes.link}
                >
                  DBMS
                </Link>
                <Link
                  color={'primary'}
                  href={'https://flatlogic.com/about'}
                  target={'_blank'}
                  className={classes.link}
                >
                  About Us
                </Link>
                <Link
                  color={'primary'}
                  href={'https://flatlogic.com/blog'}
                  target={'_blank'}
                  className={classes.link}
                >
                  Blog
                </Link>
              </div>
              <div>
                <Link
                  href={'https://www.facebook.com/flatlogic'}
                  target={'_blank'}
                >
                  <IconButton aria-label="facebook">
                    <Icon
                      path={FacebookIcon}
                      size={1}
                      color="#6E6E6E99"
                    />
                  </IconButton>
                </Link>
                <Link
                  href={'https://twitter.com/flatlogic'}
                  target={'_blank'}
                >
                  <IconButton aria-label="twitter">
                    <Icon
                      path={TwitterIcon}
                      size={1}
                      color="#6E6E6E99"
                    />
                  </IconButton>
                </Link>
                <Link
                  href={'https://github.com/flatlogic'}
                  target={'_blank'}
                >
                  <IconButton
                    aria-label="github"
                    style={{marginRight: -12}}
                  >
                    <Icon
                      path={GithubIcon}
                      size={1}
                      color="#6E6E6E99"
                    />
                  </IconButton>
                </Link>
              </div>
            </Box>
          </div>
        </>
    </div>
  );
}

export default withRouter(Layout);
